export default class SiteDrawers extends HTMLElement {
  constructor () {
    super()

    if (this.hasAlreadyBeenUsed) {
      throw new Error(
        `You can only use 1 instance of ${this.nodeName.toLowerCase()}`,
      )
    }

    this.setupListeners()

    this._activeDrawerKey = ''
    this.drawers = []

    window.drawers = this

    if (this.triggerKeys.length) {
      this.drawerKeys
        .filter((key) => !this.triggerKeys.includes(key))
        .forEach((key) =>
          console.info(`Drawer exists for ${key} but there is no trigger`),
        )
    }
  }

  setupListeners () {
    document.documentElement.addEventListener('click', this.handleClick.bind(this))
    document.documentElement.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.activeDrawerKey = ''
      }
    })
  }

  handleClick (e) {
    const targetKey = e.target.closest(this.config.matches.trigger)?.dataset.facet

    if (targetKey) {
      this.accordionKeys.forEach((itemEl) => {
        const isMatch = itemEl.dataset.drawersAccordion === targetKey

        itemEl.setAttribute('aria-expanded', isMatch ? 'true' : 'false')

        const focusableSelectors =
          'button:not([data-filter-accordions-el="trigger"]), input'

        const focusableEls = itemEl.querySelectorAll(focusableSelectors)

        focusableEls.forEach((el) => {
          if (isMatch) {
            el.removeAttribute('tabindex')
          } else {
            el.setAttribute('tabindex', '-1')
          }
        })
      })
    }

    const EVENTS = {
      TRIGGER: 'TRIGGER',
      CLOSE: 'CLOSE',
      BACKDROP: 'BACKDROP',
      UNKNOWN: 'UNKNOWN',
    }

    const eventType = (() => {
      if (e.target.closest(this.config.matches.trigger) !== null) {
        return EVENTS.TRIGGER
      } else if (e.target.closest(this.config.matches.close) !== null) {
        return EVENTS.CLOSE
      } else if (e.target.closest(this.config.matches.backdrop) !== null) {
        return EVENTS.BACKDROP
      } else if (e.target.closest(this.config.matches.drawer) !== null) {
        if (e.detail !== 0) {
          const dialogDimensions = e.target
            .closest(this.config.matches.drawer)
            .getBoundingClientRect()

          if (
            e.clientX < dialogDimensions.left ||
            e.clientX > dialogDimensions.right ||
            e.clientY < dialogDimensions.top ||
            e.clientY > dialogDimensions.bottom
          ) {
            return EVENTS.BACKDROP
          }
        }
      }

      return EVENTS.UNKNOWN
    })()

    if (eventType === EVENTS.UNKNOWN) return

    if (eventType === EVENTS.TRIGGER) {
      e.preventDefault()
      const trigger = e.target.closest(this.config.matches.trigger)
      const key = trigger.getAttribute('data-drawers-trigger')

      this.activeDrawerKey = key === this.activeDrawerKey ? '' : key
    }

    if (eventType === EVENTS.CLOSE || eventType === EVENTS.BACKDROP) {
      e.preventDefault()
      this.activeDrawerKey = ''
    }
  }

  /**
   * @param {string} key
   */
  open (key) {
    this.activeDrawerKey = key
  }

  close () {
    this.activeDrawerKey = ''
  }

  get triggerKeys () {
    const drawerTriggers = document.querySelectorAll('[data-drawers-trigger]')

    return drawerTriggers.length ? Array.from(drawerTriggers).map((el) =>
      el.getAttribute('data-drawers-trigger'),
    ) : []
  }

  get drawerKeys () {
    const drawerKeyEls = document.querySelectorAll('[data-module-drawers-drawer]')

    return Array.from(drawerKeyEls).map((el) =>
      el.getAttribute('data-module-drawers-drawer'),
    )
  }

  get accordionKeys () {
    return document.querySelectorAll('[data-drawers-accordion]')
  }

  get hasAlreadyBeenUsed () {
    const el = document.querySelector(this.nodeName.toLowerCase())

    return el !== this
  }

  get aDrawerIsOpen () {
    return this.drawers.some((drawer) => drawer.isOpen)
  }

  get activeDrawerKey () {
    return this._activeDrawerKey
  }

  set activeDrawerKey (key) {
    this._activeDrawerKey = key
    this.drawers.forEach((drawer) => (drawer.isOpen = drawer.key === key))

    this.config.elements.drawers.classList.toggle(
      this.config.classes.activeClass,
      this.aDrawerIsOpen,
    )
    document.body.classList.toggle(
      this.config.classes.siteOverflowed,
      this.aDrawerIsOpen,
    )
    document.body.classList.toggle(
      this.config.classes.drawersOpenUtility,
      this.aDrawerIsOpen,
    )

    const drawerEl = this.querySelector('[data-site-drawers-el="drawer"]')

    if (key !== '') {
      drawerEl.classList.add('drw-Drawers_Drawer-active')
      document.body.classList.add(`drw-Drawers-${key}`)
    } else {
      drawerEl.classList.remove('drw-Drawers_Drawer-active')
    }

    document.dispatchEvent(new CustomEvent('drawer-changed'))
  }

  get config () {
    return {
      matches: {
        trigger: '[data-drawers-trigger]',
        subNav: '[data-drawers-sub-nav]',
        close: '[data-drawers-close]',
        backdrop: '[data-site-drawers-el="backdrop"]',
        drawer: '[is="site-drawer"]',
      },
      classes: {
        activeClass: 'drw-Drawers-active',
        activeDrawerClass: 'drw-Drawer-active',
        siteOverflowed: 'util-SiteOverflowed',
        drawersOpenUtility: 'util-DrawersOpen',
      },
      elements: {
        body: document.body || document.documentElement,
        backdrop: '[data-site-drawers-el="backdrop"]',
        drawers: document.querySelector('site-drawers'),
      },
    }
  }
}

customElements.define('site-drawers', SiteDrawers)
